import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

import { RecommendationsModal } from '../components/RecommendationsModal';
import { formatPeriod } from '../utils/periodGenerator';
import { useUpdateRecommendationsMutation } from '../service/recommendations-ai.api';
import { useAppSelector } from '../../../../../store';
import { selectCurrentRecommendation } from '../store/recommendationAISlice';
import validationSchema from '../utils/form';
import { RecommendationsProps } from '../service/recommendations.interface';

export const RecommendationsEditContainer = () => {
    const { notification } = App.useApp();
    const navigate = useNavigate();
    const currentRecommendation = useAppSelector(selectCurrentRecommendation);

    if (!currentRecommendation) return;

    const [updateRecommendations, { isSuccess, isLoading }] =
        useUpdateRecommendationsMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Рекомендации настроены',
                description: 'Изучить подробнее можно в истории.',
            });
            navigate(-1);
        }
    }, [isSuccess]);

    const onSubmit = () => {
        updateRecommendations({
            id: currentRecommendation.id,
            payload: formik.values,
        });
    };

    const formik = useFormik<RecommendationsProps>({
        initialValues: {
            period: formatPeriod(currentRecommendation.interval_hours),
            community_ids: currentRecommendation.communities.map(c =>
                c.id.toString()
            ),
        },
        enableReinitialize: true,
        onSubmit: onSubmit,
        validationSchema: validationSchema,
    });

    return (
        <RecommendationsModal
            isLoading={isLoading}
            onSubmit={onSubmit}
            formik={formik}
        />
    );
};
